import styled from 'styled-components';

export const CarouselContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;
  position: relative;
  padding: 0 46px;

  .slick-slider {
    position: relative;
  }

  .slick-prev,
  .slick-next {
    width: 38px;
    height: 38px;
    border-radius: 999px;
    border: 1px solid rgba(12, 58, 114, 0.22);
    background: #ffffff;
    color: #0c3a72;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    z-index: 3;
    transition: transform 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
  }

  .slick-prev::before,
  .slick-next::before {
    display: none;
  }

  .slick-prev {
    left: -42px;
  }

  .slick-next {
    right: -42px;
  }

  .slick-prev:hover,
  .slick-next:hover,
  .slick-prev:focus-visible,
  .slick-next:focus-visible {
    background: #eef5fd;
    box-shadow: 0 6px 14px rgba(12, 58, 114, 0.18);
    outline: none;
  }

  .slick-prev.slick-disabled,
  .slick-next.slick-disabled {
    opacity: 0.45;
    cursor: not-allowed;
    box-shadow: none;
    transform: none;
  }

  .slick-prev svg,
  .slick-next svg {
    font-size: 21px;
  }

  @media (max-width: 900px) {
    padding: 0 36px;

    .slick-prev {
      left: -30px;
    }

    .slick-next {
      right: -30px;
    }
  }

  @media (max-width: 480px) {
    padding: 0;
  }
`;

export const CarouselImage = styled.img`
  max-width: 100%;
  min-width: 177px;
  height: 176px;
  margin-right: 20px;
  opacity: 0.4;
`;
